import React from "react";
import "materialize-css/dist/js/materialize.min.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faLaptopCode } from "@fortawesome/free-solid-svg-icons";
import { faJava } from "@fortawesome/free-brands-svg-icons";

class Introduction extends React.Component {
  render() {
    return (
      <div id="Introduction" className="section">
        <div class="thirteen">
          <h1 class="text">Full Stack Developer</h1>
        </div>

        <div className="main-container">
          <div className="container">
            <div>
              <h2 className="white-text">
                <span>
                  <FontAwesomeIcon icon={faHeart} color="red" />{" "}
                  <FontAwesomeIcon icon={faLaptopCode} color="#43719F" />{" "}
                  <FontAwesomeIcon icon={faJava} color="#ED1D25" />
                </span>
              </h2>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Introduction;
